export const REFUND_CONSTANTS = {
  OTP_VALID_LENGTH: 6,
  ACTION_BUTTON_HEIGHT: 50,
  VALID_MOBILE_LENGTH: 10,
  Debit: 'Debit',
  Name: 'Name',
  Account: 'Account',
  UTR_LENGTH: 16,
  Material: 'Material',
}
